import { Record } from 'immutable';
import PropTypes from 'prop-types';

const prefix = 'publish_ui';

export const PUBLISH_LESSON_UI_PREFIX = prefix;

export const INIT                = `${prefix}/INIT`;
export const SET_TARGET          = `${prefix}/SET_TARGET`;
export const SET_RELEASE_DATE    = `${prefix}/SET_RELEASE_DATE`;
export const SET_PREVIEW_STATE   = `${prefix}/SET_PREVIEW_STATE`;
export const ACKNOWLEDGE_PUBLISH = `${prefix}/ACKNOWLEDGE_PUBLISH`;

export const BEGIN_PUBLISH     = `${prefix}/BEGIN_PUBLISH`;
export const PUBLISH_SUCCEEDED = `${prefix}/PUBLISH_SUCCEEDED`;
export const PUBLISH_FAILED    = `${prefix}/PUBLISH_FAILED`;

export const PREVIEW_LOADING = 'LOADING';
export const PREVIEW_READY   = 'READY';
export const PREVIEW_FAILURE = 'FAILURE';

export const PreviewStateType = PropTypes.oneOf([
  PREVIEW_LOADING,
  PREVIEW_READY,
  PREVIEW_FAILURE,
]);

export enum PublishStateType {
  Working   = 'WORKING',
  Succeeded = 'SUCCEEDED',
  Failed    = 'FAILED',
}

export class PublishState extends Record<{
  createdID: string | null,
  failure:   Error | null,
  state:     PublishStateType | null,
}>({
  createdID: null,
  failure:   null,
  state:     null,
}, 'PublishState') {}
